import { useState, useEffect } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { twMerge } from 'tailwind-merge';
interface AvailabilityUrlCopyProps {
  availabilityUrl: string;
  label?: string;
  className?: string;
  btnClassName?: string;
}

export function AvailabilityUrlCopy({
  availabilityUrl,
  label = 'Share Availability',
  className,
  btnClassName,
}: AvailabilityUrlCopyProps) {
  const [showCopied, setShowCopied] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (showCopied) {
      timeout = setTimeout(() => {
        setShowCopied(false);
      }, 2000);
    }
    return () => clearTimeout(timeout);
  }, [showCopied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(availabilityUrl);
      setShowCopied(true);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className={twMerge('tw:flex tw:justify-end tw:mb-1', className)}>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="copy-availability-url-tooltip">
            {showCopied ? 'Copied to clipboard!' : 'Click to Copy Link'}
          </Tooltip>
        }
      >
        <Button
          variant="link"
          className={twMerge(
            'tw:p-0 tw:text-brand-green-1 tw:hover:text-brand-green-1/90 tw:no-underline',
            btnClassName
          )}
          onClick={handleCopy}
        >
          <i className="far fa-clone tw:mr-1" />
          <span className="tw:text-sm tw:font-medium">{showCopied ? 'Copied!' : label}</span>
        </Button>
      </OverlayTrigger>
    </div>
  );
}

export default AvailabilityUrlCopy;
